import i18n from "../i18n";

export interface BridgePainPoint {
  emoji: string;
  text: string;
  variant: 'negative' | 'positive';
}

export interface BridgeScreenConfig {
  layout?: "default" | "compact";
  sectionLabel: string;
  headline: {
    prefix: string;
    highlighted: string;
  };
  subheadline: string;
  painPoints: BridgePainPoint[];
  socialProof?: {
    emoji: string;
    count: string;
    text: string;
  };
  cta: string;
}

// Bundled fallback, shown only when the Bridge CMS is unreachable or has no
// bridge for the angle. Text lives in locales/<lng>/bridge.json (bridge.fallback.*)
// and is resolved on each call, so it follows the active language.
const t = (key: string) => i18n.t(`bridge.fallback.${key}`);

export function getBundledBridgeContent(): Record<string, BridgeScreenConfig> {
  return {
    cut_bodyfat: {
      sectionLabel: t("cutBodyfat.sectionLabel"),
      headline: {
        prefix: t("cutBodyfat.headlinePrefix"),
        highlighted: t("cutBodyfat.headlineHighlighted"),
      },
      subheadline: t("cutBodyfat.subheadline"),
      painPoints: [
        {
          emoji: "\u{1F624}",
          text: t("cutBodyfat.painPoints.eatingLess"),
          variant: "negative",
        },
        {
          emoji: "\u{1F504}",
          text: t("cutBodyfat.painPoints.losingMuscle"),
          variant: "negative",
        },
        {
          emoji: "\u2705",
          text: t("cutBodyfat.painPoints.plan"),
          variant: "positive",
        },
      ],
      socialProof: {
        emoji: "\u{1F4AA}",
        count: "110,247",
        text: t("cutBodyfat.socialProof"),
      },
      cta: t("buildMyCustomPlan"),
    },
    cut_bodyfat2: {
      layout: "compact",
      sectionLabel: t("cutBodyfat2.sectionLabel"),
      headline: {
        prefix: t("cutBodyfat2.headlinePrefix"),
        highlighted: t("cutBodyfat2.headlineHighlighted"),
      },
      subheadline: t("cutBodyfat2.subheadline"),
      painPoints: [],
      cta: t("buildMyCustomPlan"),
    },
    cut_bodyfat3: {
      layout: "compact",
      sectionLabel: t("cutBodyfat3.sectionLabel"),
      headline: {
        prefix: t("cutBodyfat3.headlinePrefix"),
        highlighted: t("cutBodyfat3.headlineHighlighted"),
      },
      subheadline: t("cutBodyfat3.subheadline"),
      painPoints: [],
      cta: t("buildMyCustomPlan"),
    },
  };
}
